import { Component, ViewEncapsulation, EventEmitter, Output, Input, OnChanges } from '@angular/core';
import { ServerPagingResult, GridV2Dto, GridColumnV2Dto } from '@hub/generated/models';
import { IOnLazyLoad } from '@hub/interfaces/IOnLazyLoad';
import { SortMeta } from 'primeng/api';
import { GridStylingDto } from '@hub/models/grids/GridStylingDto';


@Component({
  selector: 'main-grid-v2',
  templateUrl: 'main-grid.component.html',
  styleUrls: ['./main-grid.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainGridV2Component implements OnChanges {


  @Input() ActiveFlag: string;
  @Input() PagingResult: ServerPagingResult<any>;
  @Input() RowsPerPageOptions: Number[];
  @Input() Sorting: SortMeta[];
  @Input() FooterText: String;
  @Input() IsGridEdit: boolean = false;
  @Input() Grid: GridV2Dto;
  @Input() ShowRedirectHeader: boolean;
  @Input() Styling: GridStylingDto<any>;
  @Input() IsEmptyMessage: boolean = true;
  @Input() IsGridChanged: boolean = false;

  @Output() gridColumnSettings: EventEmitter<any> = new EventEmitter();
  @Output() gridChangeCompleted: EventEmitter<any> = new EventEmitter();
  @Output() onLazyLoad: EventEmitter<any> = new EventEmitter();
  @Output() onShowOptions: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();

  @Output() selectionChange = new EventEmitter();
  @Input() selection: any[] = [];

  @Output() gridDataChange = new EventEmitter<GridV2Dto>();

  columns: GridColumnV2Dto[] = [];

  ngOnChanges() {
    if(this.Grid && this.Grid.Columns) {
      this.columns = this.Grid.Columns;
    }
  }

  OnLazyLoad(event: IOnLazyLoad) {
    this.onLazyLoad.emit(event);
  }

  public toggleOptions(val: IOnLazyLoad) {
    this.onShowOptions.emit(val);
  }

  onGridDataChange(event) {
    this.Grid = event;
    this.columns = this.Grid.Columns;
    this.gridDataChange.emit(event);
  }

  columnSettingChange(event) {
    this.Grid.Columns = event.filter(x => x != undefined);
    this.gridDataChange.emit(this.Grid);
  }

  onSelectionChange(event) {
    this.selectionChange.emit(this.selection);
  }

  onGridChangeCompleted() {
    this.gridChangeCompleted.emit();
  }
}
